import { Component } from '@angular/core';
import { ResourceService } from 'sce-core';
import { SearchableEntityConfig } from '../../../../shared/models/searchable-entity-config';
import { ReportsConfigurationButtonService } from '../services/reports-configuration-button.service';
import { ReportsConfigurationActionService } from '../services/reports-configuration-action.service';
import { ReportsConfigurationBackendService } from '../services/reports-configuration-backend.service';
import { ReportsConfigurationDataService } from '../services/reports-configuration-data.service';
import { ReportConfigurationSearchService } from '../services/reports-configuration-search.service';
import { ReportsConfigurationDataEditorService } from '../services/reports-configuration-data-editor.service';
import { ReportsConfigurationAccordionComponent } from './reports-configuration-accordion/reports-configuration-accordion.component';

@Component({
  selector: 'lfwms-reports-configuration-home',
  templateUrl: './reports-configuration-home.component.html',
  styleUrls: ['./reports-configuration-home.component.css'],
  providers: [ ReportsConfigurationDataService,
    ReportsConfigurationActionService,
    ReportsConfigurationBackendService,
    ReportsConfigurationDataEditorService,
    ReportsConfigurationButtonService,
    ReportConfigurationSearchService ]
})
export class ReportsConfigurationHomeComponent {
  constructor(protected resourceService: ResourceService, protected dataService: ReportsConfigurationDataService,
    protected buttonService: ReportsConfigurationButtonService) {
    dataService.initializeEntityConfiguration(this.createEntityConfig());
    dataService.initializePrimarySearchContext();
  }

  protected createEntityConfig(): SearchableEntityConfig {
    const entityConfig = new SearchableEntityConfig('Reports Configuration');
    entityConfig.setPageTitle(this.resourceService.get('lbl_reports_config'));
    entityConfig.setItemLabel(this.resourceService.get('lbl_reports_config'));
    entityConfig.setBreadCrumbPrefix('Reports Configuration #');
    entityConfig.initializePrimarySearchForTableId('wmreportsearchtd', 'reportId');
    entityConfig.initializeDetailSearchForTableId('wmreportdetailtd', 'reportLineNo');
    entityConfig.setSearchPageRoute('/home/reports/reports-config/search');
    entityConfig.setDetailPageRoute('/home/reports/reports-config/details');
    entityConfig.setUseAdvancedTable(true);
    entityConfig.initializeConfigForTemplate1();
    entityConfig.getPrimarySearchParams().autoGenerateIdProperty = false;
    // Overriding Primary Accordion Component
    entityConfig.formPageConfig.columnGroupComponentConfig = { 'Primary': ReportsConfigurationAccordionComponent};
    entityConfig.formPageConfig.pageLabel = 'Reports Configue';
    return entityConfig;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/reports/reports-configuration/reports-configuration-home/reports-configuration-home.component.ts